"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCyprusStatsConfigured = exports.cyprusStatsConfig = void 0;
var cyprusStatsConfig = {
    userApi: process.env.CYPRUS_STATS_USER_API || "",
    orderApi: process.env.CYPRUS_STATS_ORDER_API || "",
    paymentApi: process.env.CYPRUS_STATS_PAYMENT_API || "",
    btbApi: process.env.CYPRUS_STATS_BTB_API || "",
    btbCampaignId: process.env.CYPRUS_STATS_BTB_CAMPAIGN_ID || "",
};
exports.cyprusStatsConfig = cyprusStatsConfig;
var isCyprusStatsConfigured = Object.values(cyprusStatsConfig).every(Boolean);
exports.isCyprusStatsConfigured = isCyprusStatsConfigured;
